import styled from "styled-components";

export const WeatherInfoContainer = styled.div`
    font-family: "S-Core-Dream";
    padding: 0 16px;

    .titleLb {
        color: #212529;
        font-size: 24px;
        font-weight: 600;
    }
    .timeLb {
        font-size: 18px;
        color: #495057;
        font-weight: 600;
        font-family: S-Core-Dream;
        letter-spacing: -0.5px;
    }

    .weatherCard {
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 16px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.06);
        padding: 28px 24px;
        margin: 20px 0;
        display: flex;
        align-items: center;
        gap: 24px;
    }

    .weatherIconWrap {
        width: 90px;
        height: 90px;
        min-width: 90px;
        background: linear-gradient(145deg, #f0f0f0, #e6e6e6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: -4px -4px 12px rgba(255,255,255,0.8), 4px 4px 12px rgba(91,115,134,0.25);
        img {
            width: 60px;
            height: 60px;
        }
    }

    .weatherStats {
        flex: 1;
    }

    .tempLb {
        font-size: 28px;
        color: #212529;
        font-family: 'Roboto';
        font-weight: 500;
        margin-bottom: 4px;
    }

    .rainRateLb {
        font-size: 20px;
        color: #6c757d;
        font-family: 'Roboto';
    }

    .topTxt {
        font-size: 10px;
        vertical-align: top;
    }

    .weatherInfoLb {
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 12px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.04);
        padding: 20px;
        margin: 0 0 16px;
        text-align: left;
        font-weight: 400;
        font-size: 15px;
        line-height: 28px;
        font-family: S-Core-Dream;
        color: #495057;
    }

    .hide { display: none; }

    .about {
        font-size: 12px;
        position: fixed;
        right: 0;
        bottom: 0;
        margin: 15px;
        color: #adb5bd;
    }
`;
